import { observer } from 'mobx-react-lite'
import { lazy, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { ArrowLeftOutlined } from '@ant-design/icons'

import { useStore } from 'store/useStore'
import { ContainerLK } from 'sections/LKSection/shared/components/ContainerLK/ContainerLK'
import { BgBox } from 'sections/LKSection/shared/components/UI/BgBox/BgBox'
import { Margin, Padding } from 'components/ui'
import { Button, Flex, Steps, Text, Title } from 'components/uiKit'
import { useAsyncEffect } from 'utils/hooks/useAsyncEffect'

import { EmployeeKeys } from '../../data'
import { EmployeeRolesStep } from './Steps/EmployeeRolesStep/EmployeeRolesStep'
import { PersonalEmployeeDataStep } from './Steps/PersonalEmployeeDataStep/PersonalEmployeeDataStep'
import { VerificationEmployeeStep } from './Steps/VerificationEmployeeStep/VerificationEmployeeStep'

const stepTitles = [
  {
    title: 'Данные сотрудника',
  },
  {
    title: 'Код подтверждения',
  },
  {
    title: 'Дополнительные параметры',
  },
]

const steps: Map<number, JSX.Element> = new Map([
  [1, <PersonalEmployeeDataStep key={1} />],
  [2, <VerificationEmployeeStep key={2} />],
  [3, <EmployeeRolesStep key={3} />],
])

const getKey = (key: string) => `${EmployeeKeys.addEmployeePage}.${key}`

const AddEmployeePage = observer(() => {
  const { viewEmployeeUiStore: uiStore, viewPvzUiStore } = useStore()

  const { pvzId } = useParams()
  const navigate = useNavigate()
  const { t } = useTranslation()

  const items = stepTitles.map((item) => ({ key: item.title, title: <Text>{t(getKey(item.title))}</Text> }))

  useAsyncEffect(async () => {
    if (viewPvzUiStore.pvzList.length === 0) {
      await viewPvzUiStore.getPvzList()
    }

    if (pvzId) {
      await viewPvzUiStore.switchPvz(+pvzId)
    }
  }, [])

  useEffect(() => {
    document.getElementById('routeScrollId')?.scrollTo(0, 0)
  }, [uiStore.selectedStep])

  return (
    <ContainerLK>
      <Padding py={32}>
        <Margin mb={32}>
          <Flex gap={16} align="center">
            <Button shape="circle" icon={<ArrowLeftOutlined />} onClick={() => navigate(-1)} />

            <Title>{t(getKey('Добавление сотрудника'))}</Title>
          </Flex>
        </Margin>

        <Flex vertical>
          <Margin mb={16}>
            <BgBox>
              <Steps current={uiStore.selectedStep - 1} items={items} />
            </BgBox>
          </Margin>

          <Flex vertical gap={60}>
            {steps.get(uiStore.selectedStep)}
          </Flex>
        </Flex>
      </Padding>
    </ContainerLK>
  )
})

export default AddEmployeePage

export const AddEmployeePageAsync = lazy(() => import('./AddEmployeePage'))
